import axios from 'axios'
import config from '../config/dev.json'
import Vue from 'vue'
import { refresh } from './auth.service.js'

let path = '/api/v1'
let url = config.host + path + '/secure/dashbord'
let urlUp = config.host + path + '/file'

import production from '../config/production.json'

if( process.env.NODE_ENV === 'production'){
  url = production.host + path +'/secure/dashbord'
}
export async function updateUtteranceDash(express){
  return new Promise((resolve, rejetc) => {
    let obj = {
      intent:{ 
        _id: '',
        name: ''
      },
      _id: '',
      source: '',
      language:{
        isocode: '',
        _id: ''
      }
    }
    obj.intent = express.intent
    obj.source = express.utt.source
    obj.language = express.utt.language
    obj._id = express.utt._id
    let id = obj._id
    axios.put(url +'/update/'+ id, obj).then((response) => {
      let expression = response.data.data
      resolve(expression)
    }).catch(err => rejetc(err))
  })
}


export async function rahmaNLP(idbot, namebot, traduction){
  return new Promise((resolve, reject) => {
    axios.get(url +'/rahmadash/'+idbot+'/'+namebot+'/'+traduction).then((response) => {
      let dashbord = response.data.data
      resolve(dashbord)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getIntentById(id))
        }).catch(err => reject(err))
      }
    })
  })
}



export async function getAlldashbordsbyBot(id) {
  return new Promise((resolve, reject) => {
    axios.get(url+ '/bot/get/'+ id).then((response) => {
      let dashboards = response.data.data
      resolve(dashboards)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getAlldashbordsbyBot())
        }).catch(err => reject(err))
      }
    })
  })
}





// WEBPACK FOOTER //
// ./src/api/dashbord.service.js